import React, {useState} from "react";
import { useLocation } from "react-router-dom"
import { getLandingPage } from "../utils/common";

const SuccessSaas = () => {
    const [status_title] = useState("Whooo, your account is all setup!")
    const [status_message] = useState("You are being redirected to your new SMS-Magic account. Alternatively, you may click the below button to get in!")
    var success_map = new Map([["sf", "Thank you for submitting your response. We are in the process of creating your trial account. Our sales team will connect with you soon!"],
    ["zoho", "Hey, Thank you for signing up. We have sent you an email for verification to your inbox. Post email verification, we will begin to set up your trial account and you can login to our product via Zoho SSO Login.Please check your email for what to expect next."],
    ["saas", "Hey, Thank you for signing up. We have sent you an email for verification to your inbox. Post email verification, you can set your credential and we will begin to set up your trial account. Please check your email for what to expect next."],
    ["is_register", "Thank you for submitting your request. There is already an account with same email address. Request to login using same or reset it using forgot password option."]])
    const redirectToPortal = (landingPageUrl) => {
        console.log(`inside redirectToPortal with landing page url: ${landingPageUrl}`);
        window.location = landingPageUrl
    };
    const location = useLocation()
    var props = location.state;
    console.log("props: ", props)
    if (!props) {
        console.log("no props navigating to form page");
        window.location = '/trial';
    } else if (props.crm_name !== 'sf') {
        let landingPageUrl = getLandingPage(props.crm_name, props.plan_name);
        setTimeout(redirectToPortal(landingPageUrl), 3000);
        return (
                <div className='sign-up padding-top-95'>
                    <div className="container-sm">
                        <div className="row justify-content-md-center">
                            <div className="trial-account-wrapper success-step">
                                <a className="magic-logo" href="https://www.sms-magic.com/"><img src="https://staging.txtbox.in/wp-content/uploads/2021/11/SMS-Magic_Logo.png" className="logo-align" alt="SMS Magic"/></a>
                                <div className="my-5">
                                    <div className="d-flex justify-content-center">
                                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                        </svg>
                                    </div>
                                    <div className="success-message">
                                        <h3 className="mt-5 mb-4">{status_title}</h3>
                                        <div className="d-flex justify-content-center">
                                            <p className="mt-2 col-lg-6 col-md-10 col-sm-12 px-4 sign-in-redirect-text">{status_message}</p>
                                        </div>
                                        <a class="btn btn-primary link-btn p-2 mt-4" href={landingPageUrl} role="button">Explore SMS-Magic</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className='sign-up padding-top-95'>
                    <div className="container-sm">
                        <div className="row justify-content-md-center">
                            <div className="col col-sm-12 col-md-12 col-lg-8 col-xl-7">
                                <div className="trial-account-wrapper success-step">
                                    <a className="magic-logo" href="https://www.sms-magic.com/"><img src="https://staging.txtbox.in/wp-content/uploads/2021/11/SMS-Magic_Logo.png" className="logo-align" alt="SMS Magic"/></a>
                                    <img src="https://staging.txtbox.in/wp-content/uploads/2021/11/abracadabra.svg" className="abra-img" alt="Abracadabra"/>
                                    <div className="trial-txt product-salesforce">
                                        <h3>Abracadabra!</h3>
                                        <p className="trial-created">{success_map.get(`${props.crm_name}`)}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            );
        }
};


export default SuccessSaas;
